// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1L6LX","amount":"Amount_amount__2p74d","tip":"Amount_tip__2iZHK","tipHeader":"Amount_tipHeader__5gZq3","tipsWrap":"Amount_tipsWrap__1wG16"};